import React from "react";
import PropTypes from "prop-types";
import CountyAutocompleteField from "../../../features/bonds/shared/components/CountyAutocompleteField";

export default function EndorsementCountyField({
  counties,
  loadingCounties,
  endorsementToCounty,
  setEndorsementToCounty,
}) {
  return (
    <CountyAutocompleteField
      options={counties}
      loading={loadingCounties}
      value={endorsementToCounty}
      onChange={(event, selected) =>
        setEndorsementToCounty(selected ? selected.value : "")
      }
      label="To County"
      sx={{ mb: 3 }}
    />
  );
}

EndorsementCountyField.propTypes = {
  counties: PropTypes.array.isRequired,
  loadingCounties: PropTypes.bool.isRequired,
  endorsementToCounty: PropTypes.string,
  setEndorsementToCounty: PropTypes.func.isRequired,
};
